import { render } from "./CertificadoSection.vue?vue&type=template&id=325dc7a2&ts=true"
import script from "./CertificadoSection.vue?vue&type=script&lang=ts"
export * from "./CertificadoSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__